import React, { useState } from 'react'
import { ACCEPTED_IMAGE_EXTENSIONS } from '../constants'
import SkuMediaDropzone from '../SkuMediaDropzone'
import { validateProductMediaFile } from '../utils'

function MultiImageDropzone({ files, onFilesChange, disabled }) {
  const [selectionErrors, setSelectionErrors] = useState([])

  const addFiles = (incomingFiles) => {
    const fileList = Array.from(incomingFiles || [])
    if (!fileList.length) {
      return
    }

    const errors = []
    const validFiles = []

    fileList.forEach((file) => {
      const validationError = validateProductMediaFile(file)
      if (validationError) {
        errors.push(`${file.name}: ${validationError}`)
      } else {
        validFiles.push(file)
      }
    })

    setSelectionErrors(errors)

    if (validFiles.length) {
      const existingNames = new Set(files.map((f) => f.name))
      onFilesChange([
        ...files,
        ...validFiles.filter((f) => !existingNames.has(f.name)),
      ])
    }
  }

  const removeFile = (index) => {
    onFilesChange(files.filter((_, i) => i !== index))
  }

  return (
    <>
      <SkuMediaDropzone
        accept={ACCEPTED_IMAGE_EXTENSIONS}
        browseKey="catalogue.skuMediaUpload.bulkUpload.dropzone.browse"
        disabled={disabled}
        dropzoneTestId="sku-media-dropzone"
        hintKey="catalogue.skuMediaUpload.bulkUpload.dropzone.hint"
        inputTestId="sku-media-file-input"
        multiple
        onFilesSelected={addFiles}
        titleKey="catalogue.skuMediaUpload.bulkUpload.dropzone.title"
      />

      {selectionErrors.length > 0 && (
        <div className="form-error" data-testid="sku-media-selection-error">
          {selectionErrors.join('\n')}
        </div>
      )}

      {files.length > 0 && (
        <ul className="sku-media-file-list" data-testid="sku-media-file-list">
          {files.map((file, index) => (
            <li key={`${file.name}-${index}`} className="sku-media-file-item">
              <span className="sku-media-file-name">{file.name}</span>
              <button
                type="button"
                className="sku-media-remove-file"
                disabled={disabled}
                onClick={() => removeFile(index)}
                aria-label={`Remove ${file.name}`}
              >
                &times;
              </button>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}

export default MultiImageDropzone
